export default {
  methods: {
    downloadCsvFile(csvContent, fileName) {
      this.downloadFile(window.URL.createObjectURL(new Blob([csvContent], { type: 'text/csv' })), fileName);
    },
    downloadZip(archive, fileName) {
      this.downloadFile(window.URL.createObjectURL(new Blob([archive], { type: 'application/octet-stream' })), fileName);
    },
    downloadFile(url, fileName) {
      const hiddenLink = document.createElement('a');
      hiddenLink.style = 'display: none';

      document.body.appendChild(hiddenLink);
      window.URL = window.webkitURL || window.URL;

      hiddenLink.href = url;
      hiddenLink.download = fileName;
      hiddenLink.click();

      window.URL.revokeObjectURL(url);
      hiddenLink.remove();
    },
  },
};
